import { useState } from 'react';
import './ConjugationTableCell.css';

function ConjugationTableElement(props) {
  const [active, setActive] = useState(false);

  const handleClick = () => {
    if (props.isRowHeader || props.isColHeader) {
      return;
    }
    setActive(!active);
  }

  return (
    <div className={`
      conjugation-table__element
      ${props.isRowHeader ? 'conjugation-table__element--row-header' : ''}
      ${props.isColHeader ? 'conjugation-table__element--col-header' : ''}
      ${active ? 'conjugation-table__element--active' : ''}`}
      onClick={handleClick}
    >
      {props.textContent}
    </div>
  )
}

export default ConjugationTableElement;
